module.exports = __webpack_public_path__ + "static/media/like.74d86f81.svg";